var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 24,
    viewBox: "0 0 204 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1016 0H0V8.31525L5.20502 11.2907V4.49205H11.7112C17.1764 4.49205 20.8849 6.80415 20.8849 11.5577C20.8849 16.3112 17.1764 18.6205 11.7112 18.6205H5.20502V13.9413H0V23.1236H12.1016C20.6898 23.1236 26.1984 18.7637 26.1984 11.5632C26.1984 4.36269 20.6898 0 12.1016 0Z",
    fill: "#4FFF8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8136 9.14429e-05V11.822C50.8136 16.4462 48.146 19.2207 43.223 19.2207C38.3 19.2207 35.6325 16.4462 35.6325 11.822V9.14429e-05H30.4275V12.2184C30.4275 19.1546 34.9493 23.8448 43.2121 23.8448C51.475 23.8448 55.9969 19.1656 55.9969 12.2184V9.14429e-05H50.8136Z",
    fill: "#4FFF8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.884 18.6922V13.6056H81.8807V9.17963H66.884V4.42609H84.841V9.14429e-05H61.7115V23.1209H85.1664V18.695L66.884 18.6922Z",
    fill: "#4FFF8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8605 18.5601V9.14429e-05H89.6557V23.1209H110.964V18.5628L94.8605 18.5601Z",
    fill: "#4FFF8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.376 9.14429e-05H123.683L111.614 23.1209H117.177L119.617 18.2325H133.377L135.817 23.1209H141.445L129.376 9.14429e-05ZM121.764 13.9414L126.481 4.53068L131.198 13.9414H121.764Z",
    fill: "#4FFF8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.42 9.14429e-05V15.8516L150.071 9.14429e-05H144.541V23.1209H149.583V6.41063L165.914 23.1209H170.468V9.14429e-05H165.42Z",
    fill: "#4FFF8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.621 13.9414H183.735L188.452 4.53067L191.787 11.1834L195.943 8.81078L191.348 0.00283182H185.655L173.586 23.1237H179.148L181.588 18.2353H195.343L197.783 23.1237H203.411L198.621 13.9414Z",
    fill: "#4FFF8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logo-name.b390a2c70daaa0c47a47f6a422b5fd3e.svg";
export { ForwardRef as ReactComponent };